export default {
  methods: {
    emitSelectedRows: function () {
      let selected = this.invoices.filter((invoice) => invoice.select === true);
      let all = [...selected, ...this.cachedInvoices];

      const ids = all.map(o => o.id)
      const filtered = all.filter(({id}, index) => !ids.includes(id, index + 1))

      this.$emit('invoices-selected', filtered);
    },
    rowSelected: function(index, value = undefined) {
      if (this.invoices[index].select === true) {
        this.removeFromCachedInvoices(this.invoices[index])
      } else {
        this.addToCachedInvoices(this.invoices[index])
      }

      this.invoices[index].select = (value === undefined) ? !this.invoices[index].select : value;
      this.emitSelectedRows();
    },
    setAll: function(value) {
      for (let i = 0; i < this.invoices.length; i++) {
        if (this.invoices[i].status === 'unpaid') {
          if (value) {
            this.addToCachedInvoices(this.invoices[i])
          } else {
            this.removeFromCachedInvoices(this.invoices[i])
          }

          this.invoices[i].select = value;
        }
      }
      this.emitSelectedRows();
    },
    selectAll: function() {
      this.setAll(true);
    },
    selectUnpaidInvoices: function (unpaidInvoices) {
      for (let i = 0; i < this.invoices.length; i++) {
        if (this.invoices[i].status === 'unpaid') {
          this.invoices[i].select = true;
        }
      }

      this.cachedInvoices = unpaidInvoices;
      this.$emit('invoices-selected', unpaidInvoices);
    },
    selectInvoices: function(invoiceCodes) {
      this.invoices = this.invoices.map((invoice) => ({...invoice, select: invoiceCodes.includes(invoice.code)}));
      this.emitSelectedRows();
    },
    deselectInvoice: function(deselectedInvoice) {
      this.invoices = this.invoices.map((invoice) => ({...invoice, select: invoice.select && (invoice.code !== deselectedInvoice.code)}));
      this.removeFromCachedInvoices(deselectedInvoice)
      this.emitSelectedRows();
    },
    canSettle: function(invoice) {
      return invoice.status === 'unpaid' && invoice.price_excluding_vat > 0
    },
    removeFromCachedInvoices: function (invoice) {
      this.cachedInvoices = this.cachedInvoices.filter(item => item.id !== invoice.id);
    },
    setMeta: function(metaData) {
      this.items = metaData.totalResults;
      this.pageSize = metaData.pageSize;
    },
    addToCachedInvoices: function (invoice) {
      if (this.cachedInvoices.find(item => item.id === invoice.id)) {
        return
      }

      this.cachedInvoices.push(invoice);
    },
    isInvoiceOverDue: function(invoiceDueDate) {
        return new Date() > new Date(invoiceDueDate);
    }
  },
  watch: {
    sort: function() {
      this.loadInvoices();
    },
    page: function() {
      this.loadInvoices();
    }
  },
  created: function() {
    this.loadInvoices();
  }
};
